import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setDairyFeedInformation } from "services";

import { FOOTPRINTING_DAIRY, FOOTPRINTING_DAIRY_PRIMARY_DATA, GET_DAIRY_FEED_INFORMATION } from "consts";

import { UploadableFeedInformation } from "models";

export const useMutateFootprintingDairyFeedInformation = (farmId: string, year: number, payload: UploadableFeedInformation[], primaryDataId: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    {
      mutationKey: [GET_DAIRY_FEED_INFORMATION],
      mutationFn: () => setDairyFeedInformation(primaryDataId, payload),
      onSuccess: async () => {
        const QKs = [
          [GET_DAIRY_FEED_INFORMATION, primaryDataId],
          [FOOTPRINTING_DAIRY_PRIMARY_DATA, primaryDataId],
          [FOOTPRINTING_DAIRY_PRIMARY_DATA, farmId, year],
          [FOOTPRINTING_DAIRY, farmId, year],
        ];
        await Promise.all(QKs.map((QK) => queryClient.invalidateQueries({ queryKey: QK })));
        await Promise.all(QKs.map((QK) => queryClient.refetchQueries({ queryKey: QK })));
      },
    },
    queryClient
  );
};
